export const getUrl = (path: string) => {
    const env = process.env.REACT_APP_ENV;

    if (env === 'dev') {
        return `${process.env.REACT_APP_DEV_API_URL}${path}`;
    }

    return path;
}